import styles from './Loader.module.scss'
import {GearLoader} from 'assets/svgs'

export const Loader = ({fullHeight = true}: {fullHeight?: boolean}) => (
  <div className={fullHeight ? styles.fullHeight : ''}>
    <div className={styles.loader}>
      <GearLoader />
      <div className={styles.heading}>Loading please wait</div>
    </div>
  </div>
)

export const LoaderWithoutText = () => (
  <div className={styles.loader}>
    <GearLoader />
  </div>
)
